import PerformingAssetsCard from "../components/PerformingAssetsCard";
import { META } from "../../../../../utils/constants";
import { AGE_RANGE_PLACEHOLDER } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { DemographicInsightsGrid } from "./MetaDemographicInsightsTables";

const MetaAgeDemographicInsightsCard = ({
  ageRows = [],
  getCostByMainCurrency,
  sx = {},
}) => {
  const { t } = useTranslationApp();

  if (!ageRows?.length) return null;

  return (
    <PerformingAssetsCard
      platform={META}
      title={t(AGE_RANGE_PLACEHOLDER)}
      previousContent={
        <DemographicInsightsGrid
          title=""
          rows={ageRows}
          getRowLabel={(row) => row?.age ?? "—"}
          getCostByMainCurrency={getCostByMainCurrency}
          sx={{ mt: 1 }}
        />
      }
      sx={sx}
    />
  );
};

export default MetaAgeDemographicInsightsCard;
